if (!customElements.get('dual-image-blur')) {
  customElements.define(
    'dual-image-blur',
    class DualImageBlur extends HTMLElement {
      connectedCallback() {
        this.images = Array.from(this.querySelectorAll('.dual-image-blur__image'));
        this.rafId = null;

        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.handleScroll = this.handleScroll.bind(this);
        this.onQueryChange = this.onQueryChange.bind(this);

        this.mobileQuery.addEventListener('change', this.onQueryChange);
        this.reducedMotionQuery.addEventListener('change', this.onQueryChange);

        this.setup();
      }

      disconnectedCallback() {
        this.teardown();
        this.mobileQuery.removeEventListener('change', this.onQueryChange);
        this.reducedMotionQuery.removeEventListener('change', this.onQueryChange);
      }

      onQueryChange() {
        this.teardown();
        this.setup();
      }

      setup() {
        if (!this.mobileQuery.matches || this.reducedMotionQuery.matches) return;

        window.addEventListener('scroll', this.handleScroll, { passive: true });
        this.updateBlur();
      }

      teardown() {
        window.removeEventListener('scroll', this.handleScroll);
        if (this.rafId) {
          cancelAnimationFrame(this.rafId);
          this.rafId = null;
        }
        this.images.forEach((img) => img.style.removeProperty('--blur-active'));
      }

      handleScroll() {
        if (this.rafId) return;
        this.rafId = requestAnimationFrame(() => {
          this.updateBlur();
          this.rafId = null;
        });
      }

      updateBlur() {
        const vh = window.innerHeight;

        this.images.forEach((img) => {
          const top = img.getBoundingClientRect().top;
          const ratio = top / vh;

          let blurActive;

          if (ratio > 0.75) {
            // Fully below visible zone — full blur
            blurActive = 1;
          } else if (ratio > 0.5) {
            // Entering: dissolve blur as image crosses from 75vh to 50vh
            blurActive = (ratio - 0.5) / 0.25;
          } else if (ratio >= 0) {
            // In the sweet spot — fully clear
            blurActive = 0;
          } else {
            // Exiting upward — re-blur proportionally as image scrolls off top
            blurActive = Math.min(Math.abs(ratio), 1);
          }

          img.style.setProperty('--blur-active', blurActive.toFixed(3));
        });
      }
    }
  );
}
